import { useEffect, useRef, useState } from "react";

const badges = [
  {
    icon: "ri-leaf-line",
    title: "嚴選天然材質",
    desc: "每一件商品皆經過嚴格篩選，確保材質天然純正，品質值得信賴。",
  },
  {
    icon: "ri-ancient-gate-line",
    title: "文化傳承",
    desc: "深耕東方文化底蘊，每件飾品都承載著千年傳承的智慧與祝福。",
  },
  {
    icon: "ri-hand-heart-line",
    title: "手作設計",
    desc: "融合傳統工藝與現代美學，每一件作品都有手作的溫度與用心。",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "用心服務",
    desc: "專業的能量飾品諮詢服務，協助每一位有緣人找到最適合的守護。",
  },
];

export default function TrustBadges() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="py-24 md:py-32 bg-white" ref={ref}>
      <div className="max-w-7xl mx-auto px-6 md:px-16">
        {/* Header */}
        <div
          className={`text-center mb-14 transition-all duration-1000 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
        >
          <div className="flex items-center justify-center gap-3 mb-5">
            <span className="w-10 h-px bg-[#8b6f47]"></span>
            <span
              className="text-[#8b6f47] text-[1rem] tracking-[0.3em] font-medium"
              style={{ fontFamily: "'Noto Serif TC', serif" }}
            >
              WHY LONGJING
            </span>
            <span className="w-10 h-px bg-[#8b6f47]"></span>
          </div>
          <h2
            className="text-[#2d2520] font-bold leading-[1.4]"
            style={{
              fontSize: "clamp(1.5rem, 3vw, 2.125rem)",
              fontFamily: "'Noto Serif TC', serif",
            }}
          >
            為什麼選擇瓏靖
          </h2>
        </div>

        {/* Badges Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {badges.map((badge, i) => (
            <div
              key={badge.title}
              className={`text-center transition-all duration-1000`}
              style={{
                transitionDelay: `${i * 120}ms`,
                opacity: visible ? 1 : 0,
                transform: visible ? "translateY(0)" : "translateY(24px)",
              }}
            >
              <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#f0e8dc] mx-auto mb-5">
                <i className={`${badge.icon} text-[#8b6f47] text-2xl`}></i>
              </div>
              <h3
                className="text-[#2d2520] font-bold mb-3"
                style={{
                  fontSize: "clamp(1.125rem, 1.5vw, 1.375rem)",
                  fontFamily: "'Noto Serif TC', serif",
                }}
              >
                {badge.title}
              </h3>
              <p
                className="text-[#7a6a5a] leading-[1.75]"
                style={{
                  fontSize: "1.1875rem",
                  fontFamily: "'Noto Serif TC', serif",
                }}
              >
                {badge.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
